import { S as Swiper } from './index-Cj6iU7wg.js';
import './swiper-core-kdoF3145.js';
import './classes-to-selector-JYvn0qt6.js';

class FeaturedImageCards extends HTMLElement {
  scrollbar = this.dataset.scrollbar === 'true';
  modules = [];

  async connectedCallback() {
    await this.loadModules();
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = Swiper(this, {
      modules: this.modules,
      slidesPerView: 1.41,
      spaceBetween: 16,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        hide: false,
        enabled: true,
        dragSize: 'auto',
        dragClass: 'swiper-scrollbar-drag',
      },
      breakpoints: {
        768: {
          slidesPerView: 3.15,
        },
        1440: {
          slidesPerView: 4.2,
        },
      },
    });
  }

  async loadModules() {
    if (this.scrollbar) {
      const { Scrollbar } = await import('./index-DHebtvlb.js');
      this.modules.push(Scrollbar);
    }
  }
}

customElements.define('featured-image-cards', FeaturedImageCards);
